var map = {
	"./asset-hyperlink.json": 580,
	"./blockquote.json": 48155,
	"./document.json": 53190,
	"./embedded-asset-block.json": 56615,
	"./embedded-entry-block.json": 73290,
	"./embedded-entry-inline.json": 15903,
	"./embedded-resource-block.json": 41267,
	"./embedded-resource-inline.json": 51354,
	"./entry-hyperlink.json": 82538,
	"./heading-1.json": 50988,
	"./heading-2.json": 10431,
	"./heading-3.json": 98998,
	"./heading-4.json": 58728,
	"./heading-5.json": 53589,
	"./heading-6.json": 4233,
	"./hr.json": 26779,
	"./hyperlink.json": 6220,
	"./list-item.json": 11413,
	"./ordered-list.json": 70712,
	"./paragraph.json": 59312,
	"./resource-hyperlink.json": 51982,
	"./table-cell.json": 88613,
	"./table-header-cell.json": 52027,
	"./table-row.json": 1915,
	"./table.json": 25977,
	"./text.json": 42420,
	"./unordered-list.json": 69321
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50134;